
export const OCUPATION_INFORMATION = {
  
    usuarioId           : (0),
    tipoEmpresaId       : [0, { updateOn: 'change' }],
    tipoPuestoEmpresaId : [0, { updateOn: 'change' }], 
   
};